import { useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import AdminDashboard from "@/components/AdminDashboard";
import WaliDashboard from "@/components/WaliDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  return (
    <AppLayout>
      {user.role === "wali" ? <WaliDashboard /> : <AdminDashboard />}
    </AppLayout>
  );
}
